import { userLogout } from "actions/userActions";

const redirect = (error: any, dispatch: any) => {
  if (
    error.message ===
    "Cannot destructure property 'token' of 'getState(...).userInfo.userInfo' as it is null."
  ) {
    dispatch(userLogout());
  }

  if (error.message === "Cannot read properties of null (reading 'token')") {
    dispatch(userLogout());
  }
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message === "Session Expired"
  ) {
    dispatch(userLogout());
  }
};

export default redirect;
